module.exports = __webpack_public_path__ + "static/img/green.c7d51e8e.png";